"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareStartDatesDescending = exports.compareStartDates = void 0;
/**
 * Ascending order
 */
var compareStartDates = function (a, b) { return new Date(a.startDate).getTime() - new Date(b.startDate).getTime(); };
exports.compareStartDates = compareStartDates;
var compareStartDatesDescending = function (a, b) {
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
};
exports.compareStartDatesDescending = compareStartDatesDescending;
//# sourceMappingURL=sorting.js.map